/**
 * `reportClientError` scopes for contained recs-hydrate failures (COM-63).
 *
 * A failed `/resources/product-recommendations` hydrate is settled hidden by
 * its reader (never a permanent skeleton) and beacons under one of these scopes
 * first — log-before-swallow. The Playwright sweep harness asserts the exact
 * strings, so they live here (not inline in the .tsx components, where a
 * non-component export would trip react-refresh lint) and the unit tests
 * import them instead of duplicating the literals.
 */

/** Add-to-cart flyout "You may also like" strip (`added-to-basket-recs.tsx`). */
export const ATC_RECS_BEACON_SCOPE = "atc-flyout-recs.hydrate";

/** Cart / PDP / homepage recs carousels (`use-cio-recs.ts`). */
export const CIO_RECS_BEACON_SCOPE = "cio-recs.hydrate";
